import { render, staticRenderFns } from "./product_market.vue?vue&type=template&id=00dd2b64&scoped=true&"
import script from "./product_market.vue?vue&type=script&lang=js&"
export * from "./product_market.vue?vue&type=script&lang=js&"
import style0 from "./product_market.vue?vue&type=style&index=0&id=00dd2b64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dd2b64",
  null
  
)

export default component.exports